/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 7/5/16.
 */

'use strict';
angular.module('prism-ui.components').controller('MediaModalController', function (
    _,
    $q,
    $scope,
    $uibModalInstance,
    clipId,
    media,
    type,
    DownloadAssetService,
    EndPointService,
    PermissionsService,
    PreviewQueryService
) {
    var self = this;

    const ViewClipProxyViewState = 'CLIP_ACTION_VIEW_PROXIES_VIEW_STATE';
    const DownloadClipProxyViewState = 'CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE';


    self.type = type;
    self.perms = {
        canViewProxy: false,
        canDownloadProxy: false
    };
    PreviewQueryService.getAssetUri(media)
        .finally(() => {
            self.media = media;
        });

    var getPermissions = function () {
        // if not a clip, allow all - at this time the package
        // manager is responsible for non-clip proxy
        // permissions

        if (clipId && !PermissionsService.isAdmin()) {
            let permissionsPromises = {
                viewClipProxy: PermissionsService.getPackagePermissions(ViewClipProxyViewState, clipId),
                downloadClipProxy: PermissionsService.getPackagePermissions(DownloadClipProxyViewState, clipId)
            };
            $q.all(permissionsPromises).then((perms) => {
                self.perms.canViewProxy = PermissionsService.hasReadPermission(perms.viewClipProxy[0].permission);
                self.perms.canDownloadProxy = PermissionsService
                    .hasReadPermission(perms.downloadClipProxy[0].permission);
            });
        } else {
            self.perms.canViewProxy = true;
            self.perms.canDownloadProxy = true;
        }
    };

    self.downloadAsset = () => {
        if (self.perms.canDownloadProxy) {
            DownloadAssetService.downloadAsset(
                self.media.assetId,
                `video_proxy.mp4`,
                DownloadAssetService.AssetType.Video,
                DownloadAssetService.ContentUse.Proxy
            );
        }
    };

    self.onDone = function () {
        $uibModalInstance.close();
    };

    getPermissions();
});
